<div class="fit-filter-assembly container">
  <mtn-map-toolbar-button icon="tag" [badgeCount]="toolbarState.badgeCountFits"
                          [color]="toolbarState.badgeCountFits ? 'green' : 'grey'"
                          [iconColor]="toolbarState.badgeCountFits ? 'green' : 'default'"
                          [matMenuTriggerFor]="fitMenu" [disabled]="!hasStandardLicense"
                          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.TOGGLE_MENU"
                          [analyticsEventParameters]="{'target': 'map-fit-filter-menu'}"
                          [matTooltip]="hasStandardLicense ? ('FIT_FILTER.TOOLTIP' | translate) : ('FIT_FILTER.TOOLTIP_LOCKED' | translate)">
  </mtn-map-toolbar-button>
</div>

<mat-menu class="wide-menu" #fitMenu="matMenu">
  <div class="fit-menu-container toolbar-menu container" mtnClickTrap [preventDefault]="false" fxLayout="column"
       style="width: 300px">
    <div class="header-container">
      <div fxLayout="row">
        <strong>{{ 'FIT_FILTER.CATEGORIES' | translate }}</strong>
        <div fxFlex></div>
        <a href="javascript:void(0)" (click)="clear()"
           [ngClass]="{'color-accent': toolbarState?.filterFitCategories, 'color-muted': !toolbarState?.filterFitCategories}">
          {{ 'FIT_FILTER.CLEAR' | translate }}
        </a>
      </div>
      <hr/>
    </div>
    <div *ngIf="form" [formGroup]="form" fxLayout="column">
      <mat-checkbox color="accent" [checked]="isAllSelected" (change)="toggleSelectAll()">
        {{ 'FIT_FILTER.ALL' | translate }}
      </mat-checkbox>
      <mat-checkbox color="accent" *ngFor="let option of options"
                    [formControlName]="option.systemName"
                    style="margin-left: 15px">
        {{ option.displayName }}
      </mat-checkbox>
      <div class="exclusive-row" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-checkbox color="accent" formControlName="isExclusive">{{ 'FIT_FILTER.EXCLUSIVE' | translate }}</mat-checkbox>
        <mtn-what-is-this [text]="EXCLUSIVE_FILTER_DEFINITION"></mtn-what-is-this>
      </div>
    </div>
  </div>
</mat-menu>
